import { AgentTemplateKind } from '@reach/shared-types/agents';
import { useFlags } from 'launchdarkly-react-client-sdk';
import type { LaunchDarklyFlags } from '../../types/launch-darkly';
import { TEMPLATE_COPY } from './agent-templates/agent-templates-copy';
import { TemplateKindIcon } from './agent-templates/TemplateKindIcon';
import styles from './AgentRow.module.css';
import { AgentToolList } from './AgentToolList';
import type { PartnerAgent } from './partner-agents-api';

const TEMPLATE_KIND_BY_AGENT_TYPE = {
  voice: AgentTemplateKind.VOICE,
  generic: AgentTemplateKind.SMS,
} as const satisfies Record<PartnerAgent['type'], AgentTemplateKind>;

const AGENT_TYPE_LABELS = {
  voice: 'Voice',
  generic: 'Generic',
} as const satisfies Record<PartnerAgent['type'], string>;

interface AgentRowProps {
  agent: PartnerAgent;
}

export const AgentRow = ({ agent }: AgentRowProps) => {
  const flags = useFlags<LaunchDarklyFlags>();
  const templatesAreEnabled = flags['enable-partner-agent-templates'] === true;
  const templateKind = TEMPLATE_KIND_BY_AGENT_TYPE[agent.type];
  const typeLabel = templatesAreEnabled
    ? TEMPLATE_COPY[templateKind].title
    : AGENT_TYPE_LABELS[agent.type];
  const typeClassName = templatesAreEnabled ? styles.template : undefined;

  return (
    <tr>
      <td>{agent.tenantName}</td>
      <td className={styles.externalId}>{agent.tenantExternalId}</td>
      <td>
        <span className={typeClassName}>
          {templatesAreEnabled && <TemplateKindIcon kind={templateKind} />}
          {typeLabel}
        </span>
      </td>
      <td>
        <AgentToolList tools={agent.tools} />
      </td>
    </tr>
  );
};
